import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6556fecc"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-title"
}, "骑行记录申述单列表", -1));
const _hoisted_2 = {
  style: {
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_layout_breadcrumb = _resolveComponent("layout-breadcrumb");
  const _component_table_page = _resolveComponent("table-page");
  const _component_detail = _resolveComponent("detail");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_drawer = _resolveComponent("el-drawer");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_layout_breadcrumb, {
    topMenuId: _ctx.topMenuId,
    onChangeTopToMenu: _ctx.changeTopToMenu,
    topMenuClick: _ctx.topMenuClick
  }, null, 8, ["topMenuId", "onChangeTopToMenu", "topMenuClick"]), _createVNode(_component_table_page, {
    fetchApi: _ctx.$api.business.recordRepresentation.getList,
    columns: $data.columns,
    topButtons: $data.topButtons,
    linkButtons: $data.linkButtons,
    selectionEnable: false,
    searchItems: $data.searchItems,
    ref: "tablePage"
  }, {
    toolBarLeft: _withCtx(() => [_hoisted_1]),
    _: 1
  }, 8, ["fetchApi", "columns", "topButtons", "linkButtons", "searchItems"]), _createVNode(_component_el_drawer, {
    modelValue: $data.detailDrawer,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.detailDrawer = $event),
    title: "停车记录申述单详情",
    direction: "rtl",
    size: "50%",
    "with-header": false,
    "close-on-click-modal": false,
    "destroy-on-close": ""
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = () => this.detailDrawer = false),
      type: "primary",
      plain: ""
    }, {
      default: _withCtx(() => [_createTextVNode("关闭")]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_detail, {
      currentId: $data.currentId,
      onAuditComplete: $options.auditComplete
    }, null, 8, ["currentId", "onAuditComplete"])]),
    _: 1
  }, 8, ["modelValue"])]);
}